/* Gassas note dictionary (assets/doftfinder-notes.js).
   Maps every raw note text (Swedish or English, any spelling) to ONE canonical note with a Swedish and an
   English name, so Vanilj, Madagaskarvanilj and Bourbonvanilj all count as vanilla.
   The first matching rule wins: specific rules first, general fallbacks last.
   The canonical id is also the handle of the note profile page (metaobject type note_profile).
   N(id, svenska, english, regex, extra search words) */
(function () {
  var rules = [];
  function N(id, sv, en, rx, alias) { rules.push({ id: id, sv: sv, en: en, rx: rx, alias: alias || '' }); }
  var MAP = { 'å': 'a', 'ä': 'a', 'ö': 'o', 'é': 'e', 'è': 'e', 'ü': 'u', 'ï': 'i', 'ô': 'o', 'á': 'a', 'à': 'a', 'ñ': 'n', 'ç': 'c' };
  function fold(s) { return String(s == null ? '' : s).toLowerCase().replace(/[åäöéèüïôáàñç]/g, function (c) { return MAP[c]; }); }

  /* ---- exceptions that must win over general rules ---- */
  N('rosepeppar', 'Rosépeppar', 'Pink pepper', /ros[ée]?peppar|rosa +peppar|pink +pepper/, 'pink pepper rose pepper');
  N('rosmarin', 'Rosmarin', 'Rosemary', /rosmarin|rosemary/);
  N('palisander', 'Palisander', 'Rosewood', /palisander|rosenträ|rosewood/, 'rosewood');
  N('kryddnejlika', 'Kryddnejlika', 'Clove', /kryddnejlik|nejlikeknopp|(^|[^a-zåäö])cloves?($|[^a-zåäö])/, 'cloves');
  N('vetiver', 'Vetiver', 'Vetiver', /vetiver/);
  N('ekmossa', 'Ekmossa', 'Oakmoss', /ekmoss|oak ?moss|trädmoss/);
  N('iris', 'Iris', 'Iris', /iris|orris/, 'orris');
  N('ambergris', 'Ambergris', 'Ambergris', /ambergris|gr[åa] ambra/);
  N('ambrox', 'Ambrox & amberträ', 'Ambrox & amberwood', /ambrox|amberträ|amber ?wood/, 'ambroxan amberwood');
  N('tobak', 'Tobak', 'Tobacco', /tobak|tobacco/);
  N('lakrits', 'Lakrits', 'Licorice', /lakrits|licorice|liquorice/);
  N('cascalone', 'Cascalone', 'Cascalone', /cascalone/);
  N('tall', 'Tall & barr', 'Pine', /medelhavstall/, 'fir spruce');
  N('frukt', 'Frukt', 'Fruit', /medelhavsfrukt/, 'fruity');
  N('ambrette', 'Ambrette', 'Ambrette', /ambrette/, 'musk seed');

  /* ---- citrus ---- */
  N('bergamott', 'Bergamott', 'Bergamot', /bergamot/);
  N('apelsinblom', 'Apelsinblom', 'Orange blossom', /apelsinblom|orange blossom/, 'orangeblossom');
  N('neroli', 'Neroli', 'Neroli', /neroli/);
  N('petitgrain', 'Petitgrain', 'Petitgrain', /petitgrain/);
  N('citrongras', 'Citrongräs', 'Lemongrass', /citrongr[aä]s|lemongrass/);
  N('verbena', 'Verbena', 'Verbena', /verben/);
  N('citron', 'Citron', 'Lemon', /citron|lemon|cedrat/, 'lemon citrus cedrat');
  N('apelsin', 'Apelsin', 'Orange', /apelsin|orange|pomerans|bigarad/, 'orange blodapelsin blood orange bigarade');
  N('grapefrukt', 'Grapefrukt', 'Grapefruit', /grapefrukt|grapefruit|pompelmo/);
  N('mandarin', 'Mandarin', 'Mandarin', /mandarin|tangerin|clementin|klementin/, 'tangerine clementine');
  N('lime', 'Lime', 'Lime', /(^|[^a-zåäö])lim(e|ett)/);
  N('kumquat', 'Kumquat', 'Kumquat', /kumquat/);
  N('yuzu', 'Yuzu', 'Yuzu', /yuzu/);
  N('pomelo', 'Pomelo', 'Pomelo', /pomelo/);
  N('citrus', 'Citrus', 'Citrus', /citrus/, 'citrus fruits');

  /* ---- fruit ---- */
  N('granatapple', 'Granatäpple', 'Pomegranate', /granat[äa]pple|pomegranate/);
  N('apple', 'Äpple', 'Apple', /(^|[^a-zåäö])(äpple|äppel|apple)/);
  N('paron', 'Päron', 'Pear', /p[äa]ron|(^|[^a-zåäö])pear/);
  N('persika', 'Persika', 'Peach', /persik|peach/);
  N('aprikos', 'Aprikos', 'Apricot', /aprikos|apricot/);
  N('plommon', 'Plommon', 'Plum', /plommon|plum/);
  N('korsbar', 'Körsbär', 'Cherry', /k[öo]rsb[äa]r|cherry/);
  N('jordgubbe', 'Jordgubbe', 'Strawberry', /jordgubb|strawberr/);
  N('hallon', 'Hallon', 'Raspberry', /hallon|raspberr/);
  N('svartvinbar', 'Svartvinbär', 'Blackcurrant', /svarta? ?vinb[äa]r|black ?currant|cassis/, 'cassis currant');
  N('rodvinbar', 'Rödvinbär', 'Redcurrant', /r[öo]da? ?vinb[äa]r|red ?currant/, 'currant');
  N('bjornbar', 'Björnbär', 'Blackberry', /bj[öo]rnb[äa]r|blackberr/);
  N('blabar', 'Blåbär', 'Blueberry', /bl[åa]b[äa]r|blueberr/);
  N('loganbar', 'Loganbär', 'Loganberry', /loganb|loganberr/);
  N('enbar', 'Enbär', 'Juniper', /enb[äa]r|juniper/);
  N('fikon', 'Fikon', 'Fig', /fikon|(^|[^a-zåäö])fig($|[^a-zåäö])/);
  N('kvitten', 'Kvitten', 'Quince', /kvitten|quince/);
  N('ananas', 'Ananas', 'Pineapple', /ananas|pineapple/);
  N('melon', 'Melon', 'Melon', /melon/, 'watermelon');
  N('mango', 'Mango', 'Mango', /mango/);
  N('passionsfrukt', 'Passionsfrukt', 'Passion fruit', /passionsfrukt|passion ?fruit/);
  N('litchi', 'Litchi', 'Lychee', /litchi|lychee/);
  N('banan', 'Banan', 'Banana', /banan/);
  N('rabarber', 'Rabarber', 'Rhubarb', /rabarber|rhubarb/);
  N('torkadfrukt', 'Torkad frukt', 'Dried fruit', /torkad[ea]? frukt|dried fruit|russin|dadel|dadlar|raisin/, 'dates raisins');
  N('vin', 'Vin & vinmust', 'Wine & grape must', /vinmust|(^|[^a-zåäö])vin($|[^a-zåäö])|(^|[^a-zåäö])wine|champagne|prosecco/, 'wine champagne must');

  /* ---- green, herbal, aromatic ---- */
  N('mynta', 'Mynta', 'Mint', /mynta|mint/, 'peppermint spearmint');
  N('basilika', 'Basilika', 'Basil', /basilik|basil/);
  N('salvia', 'Salvia', 'Sage', /salvia|(^|[^a-zåäö])sage/, 'clary sage');
  N('timjan', 'Timjan', 'Thyme', /timjan|thyme/);
  N('oregano', 'Oregano', 'Oregano', /oregano/);
  N('dragon', 'Dragon', 'Tarragon', /dragon|tarragon|estragol|estragon/, 'estragole');
  N('eukalyptus', 'Eukalyptus', 'Eucalyptus', /eukalyptus|eucalyptus/);
  N('koriander', 'Koriander', 'Coriander', /koriander|coriander/, 'cilantro');
  N('fankal', 'Fänkål', 'Fennel', /f[äa]nk[åa]l|fennel/);
  N('angelika', 'Angelika', 'Angelica', /angelika|angelica/);
  N('malort', 'Malört & artemisia', 'Wormwood & artemisia', /malört|malort|artemisia|wormwood|absint/, 'wormwood artemisia absinthe');
  N('davana', 'Davana', 'Davana', /davana/);
  N('te', 'Te', 'Tea', /(^|[^a-zåäö])te($|[^a-zåäö])|(^|[^a-zåäö])tea($|[^a-zåäö])|matcha/);
  N('gras', 'Gräs', 'Grass', /gr[äa]s(?!rot)|grass/);
  N('mossa', 'Mossa', 'Moss', /moss/);
  N('tall', 'Tall & barr', 'Pine', /(^|[^a-zåäö])(tall|gran|pine|fir)($|[^a-zåäö])|barr/, 'fir spruce');
  N('cypress', 'Cypress', 'Cypress', /cypress|cyprés/);
  N('kamfer', 'Kamfer', 'Camphor', /kamfer|camphor/);
  N('galbanum', 'Galbanum', 'Galbanum', /galbanum/);
  N('wasabi', 'Wasabi', 'Wasabi', /wasabi/);
  N('morot', 'Morot & morotsfrö', 'Carrot & carrot seed', /morot|carrot/, 'carrot seed');
  N('ginst', 'Ginst', 'Broom', /ginst|genista|(^|[^a-z])broom/, 'genista');
  N('immortelle', 'Immortelle', 'Immortelle', /immortell|helichrys|eternell/, 'helichrysum everlasting');
  N('pittosporum', 'Pittosporum', 'Pittosporum', /pittosporum/);
  N('tagetes', 'Tagetes', 'Tagetes', /tagetes|marigold|ringblomm/, 'marigold');
  N('jatamansi', 'Jatamansi', 'Jatamansi (spikenard)', /jatamansi|spikenard|nardus/, 'spikenard');
  N('cannabis', 'Cannabis', 'Cannabis', /cannabis|hampa|(^|[^a-z])hemp/, 'hemp');
  N('akervadd', 'Åkervädd', 'Field scabious', /åkervädd|akervadd|scabious/);
  N('linne', 'Linne', 'Linen', /(^|[^a-zåäö])linne|linen/, 'clean laundry');

  /* ---- flowers ---- */
  N('ros', 'Ros', 'Rose', /(^|[^a-zåäö])ros(?!é)|[a-zåäö]ros($|[^a-zåäö])|(^|[^a-zåäö])roses?($|[^a-zåäö])/, 'roses');
  N('jasmin', 'Jasmin', 'Jasmine', /jasmin/);
  N('viol', 'Viol', 'Violet', /(^|[^a-zåäö])viol(?!in)|violet/, 'violet');
  N('lavendel', 'Lavendel', 'Lavender', /lavendel|lavender/);
  N('liljekonvalj', 'Liljekonvalj', 'Lily of the valley', /liljekonvalj|lily of the valley|muguet|convallaria/, 'muguet');
  N('lilja', 'Lilja', 'Lily', /(^|[^a-zåäö])lilja|(^|[^a-zåäö])lil(y|ies)|vattenlilja/);
  N('tuberos', 'Tuberos', 'Tuberose', /tuberos|tuberose/);
  N('pion', 'Pion', 'Peony', /pion|peon/);
  N('gardenia', 'Gardenia', 'Gardenia', /gardenia/);
  N('ylang', 'Ylang-ylang', 'Ylang-ylang', /ylang/, 'ylang ylang cananga');
  N('magnolia', 'Magnolia', 'Magnolia', /magnolia/);
  N('frangipani', 'Frangipani', 'Frangipani', /frangipani|plumeria/, 'plumeria');
  N('mimosa', 'Mimosa', 'Mimosa', /mimosa/);
  N('hyacint', 'Hyacint', 'Hyacinth', /hyacint/);
  N('nejlika', 'Nejlika', 'Carnation', /nejlik|carnation/);
  N('geranium', 'Geranium', 'Geranium', /geranium|pelargon/);
  N('syren', 'Syren', 'Lilac', /syren|lilac/);
  N('akacia', 'Akacia', 'Acacia', /akacia|acacia/);
  N('orkide', 'Orkidé', 'Orchid', /orkid|orchid/);
  N('lotus', 'Lotus', 'Lotus', /lotus/);
  N('kamomill', 'Kamomill', 'Chamomile', /kamomill|chamomile|camomile/);
  N('flader', 'Fläder', 'Elderflower', /fl[äa]der|holunder|elderflower/);
  N('kaprifol', 'Kaprifol', 'Honeysuckle', /kaprifol|honeysuckle/);
  N('narciss', 'Narciss', 'Narcissus', /narciss|p[åa]sklilj|daffodil|jonquil/, 'daffodil');
  N('heliotrop', 'Heliotrop', 'Heliotrope', /heliotrop/);
  N('hibiskus', 'Hibiskus', 'Hibiscus', /hibiskus|hibiscus/);
  N('osmanthus', 'Osmanthus', 'Osmanthus', /osmanthus/);
  N('freesia', 'Freesia', 'Freesia', /fr[ei]esia|frisia/);
  N('champaca', 'Champaca', 'Champaca', /champaca|champak/);
  N('tulpan', 'Tulpan', 'Tulip', /tulpan|tulip/);
  N('diphylleia', 'Diphylleia (skelettblomma)', 'Skeleton flower', /diphylleia/, 'skeleton flower');
  N('vitablommor', 'Vita blommor', 'White flowers', /vita blomm|white flower/);

  /* ---- woods ---- */
  N('sandeltra', 'Sandelträ', 'Sandalwood', /sandel|sandalwood/, 'sandal');
  N('cedertra', 'Cederträ', 'Cedarwood', /ceder|cedar/, 'cedar');
  N('patchouli', 'Patchouli', 'Patchouli', /patchouli|patschuli/);
  N('oud', 'Oud', 'Oud', /(^|[^a-zåäö])oud|agarträ|agarwood|aoud/, 'agarwood');
  N('guajak', 'Guajakträ', 'Guaiac wood', /guajak|guaiac|gaiac/, 'guaiacwood gaiac');
  N('kashmirtra', 'Kashmirträ', 'Cashmere wood', /kashmir|cashmer/, 'cashmeran');
  N('cypriol', 'Cypriol (nagarmotha)', 'Cypriol (nagarmotha)', /cyprio|nagarmoth/, 'nagarmotha cypriolja cyperus');
  N('cabreuva', 'Cabreuva', 'Cabreuva', /cabreuva/);
  N('papyrus', 'Papyrus', 'Papyrus', /papyrus/);
  N('sequoia', 'Sequoia', 'Sequoia', /sequoia/);
  N('amyris', 'Amyris', 'Amyris', /amyris/);
  N('buddhatra', 'Buddhaträ', 'Buddha wood', /buddha/);

  /* ---- resins and amber ---- */
  N('rokelse', 'Rökelse', 'Incense', /r[öo]kelse|incense|frankincense|olibanum/, 'frankincense olibanum');
  N('myrra', 'Myrra', 'Myrrh', /myrra|myrrh/);
  N('bensoe', 'Bensoe', 'Benzoin', /bens[oö]|benz[oö]/, 'benzoin benzoe');
  N('labdanum', 'Labdanum', 'Labdanum', /labdanum|labdanon/);
  N('cistus', 'Cistus', 'Cistus', /cist(us|ros)|rock ?rose/, 'rockrose');
  N('tolu', 'Tolubalsam', 'Tolu balsam', /tolu/);
  N('perubalsam', 'Perubalsam', 'Peru balsam', /peru ?balsam/);
  N('elemi', 'Elemi', 'Elemi', /elemi/);
  N('mastix', 'Mastix', 'Mastic', /mastix|mastic/);
  N('gurjun', 'Gurjunbalsam', 'Gurjun balsam', /gurj[uo]n|gurjum/, 'gurjum');
  N('kopaiva', 'Kopaivabalsam', 'Copaiba balsam', /[ck]opaiva|[ck]opaiba/, 'copaiba copaiva');
  N('opoponax', 'Opoponax', 'Opoponax', /opoponax/);
  N('styrax', 'Styrax', 'Styrax', /styrax|storax/, 'storax');
  N('amber', 'Amber', 'Amber', /(^|[^a-zåäö])(amber|ambra)|bärnsten/, 'ambra');
  N('harts', 'Harts', 'Resin', /harts|resin|balsam/, 'balsam');

  /* ---- sweet and gourmand ---- */
  N('vanilj', 'Vanilj', 'Vanilla', /vanilj|vanill/, 'vanilla vanila');
  N('tonka', 'Tonkaböna', 'Tonka bean', /tonka/, 'tonka bean');
  N('kumarin', 'Kumarin', 'Coumarin', /kumarin|coumarin/);
  N('karamell', 'Karamell', 'Caramel', /karamell|caramel/, 'caramel karamel');
  N('toffee', 'Toffee', 'Toffee', /toffee|fudge/);
  N('choklad', 'Choklad', 'Chocolate', /choklad|chocolate/);
  N('kakao', 'Kakao', 'Cocoa', /kakao|cocoa|cacao/, 'cacao');
  N('kaffe', 'Kaffe', 'Coffee', /kaffe|coffee|(^|[^a-zåäö])moka/);
  N('honung', 'Honung', 'Honey', /honung|honey/);
  N('socker', 'Socker', 'Sugar', /socker|sugar|candy|godis/, 'candy');
  N('lonnsirap', 'Lönnsirap', 'Maple syrup', /lönnsirap|lonnsirap|maple/, 'maple');
  N('mandel', 'Mandel', 'Almond', /mandel|almond|amaretto|marsipan|marzipan/, 'amaretto marzipan');
  N('pralin', 'Praliné', 'Praline', /pralin|nougat/, 'nougat');
  N('bakverk', 'Bakverk & bröd', 'Pastry & bread', /croissant|(^|[^a-zåäö])kex($|[^a-zåäö])|bröd|(^|[^a-zåäö])brod($|[^a-zåäö])|bread|biscuit|cookie|brioche|pastry|bakverk/, 'croissant bread biscuit');
  N('notter', 'Nötter', 'Nuts', /hasseln|valn[öo]t|pistag|pekan|jordn[öo]t|(^|[^a-zåäö])n[öo]tt|(^|[^a-zåäö])nuts?($|[^a-zåäö])|nutty|n[öo]tig/, 'hazelnut walnut');
  N('kokos', 'Kokos', 'Coconut', /kokos|coconut/);
  N('rom', 'Rom', 'Rum', /(^|[^a-zåäö])rom($|[^a-zåäö])|romextrakt|(^|[^a-zåäö])rum($|[^a-zåäö])/, 'rum');
  N('whisky', 'Whisky & konjak', 'Whiskey & cognac', /whisk|bourbon|konjak|cognac|brandy/, 'bourbon cognac');
  N('mjolk', 'Mjölk & grädde', 'Milk & cream', /mj[öo]lk|milk|gr[äa]dde|cream/, 'milk cream');
  N('smor', 'Smör', 'Butter', /sm[öo]r|butter/);
  N('malt', 'Malt', 'Malt', /malt/);
  N('bivax', 'Bivax', 'Beeswax', /bivax|beeswax|(^|[^a-zåäö])vax|(^|[^a-zåäö])wax/, 'wax');
  N('hoy', 'Hö', 'Hay', /(^|[^a-zåäö])h[öo]($|[^a-zåäö])|(^|[^a-zåäö])hay/);
  N('lappglans', 'Läppglans', 'Lip gloss', /läppglans|lappglans|lip ?gloss/);

  /* ---- spices ---- */
  N('kardemumma', 'Kardemumma', 'Cardamom', /kardemumm|cardamom|kardamom/, 'cardamom cardamon kardemom');
  N('kanel', 'Kanel', 'Cinnamon', /kanel|cinnamon/);
  N('ingefara', 'Ingefära', 'Ginger', /ingef[äa]ra|ginger/);
  N('muskot', 'Muskot', 'Nutmeg', /muskot|nutmeg|(^|[^a-zåäö])mace/);
  N('saffran', 'Saffran', 'Saffron', /saffran|saffron/);
  N('safraleine', 'Safraleine', 'Safraleine', /safralein/);
  N('anis', 'Anis', 'Anise', /(^|[^a-zåäö])(stjärn)?anis|anise/, 'star anise');
  N('kummin', 'Kummin', 'Cumin', /kummin|cumin/);
  N('kurkuma', 'Kurkuma', 'Turmeric', /kurkuma|turmeric/);
  N('chili', 'Chili', 'Chili', /chili|cayenne|paprika/);
  N('svartpeppar', 'Svartpeppar', 'Black pepper', /svart ?peppar|black ?pepper/, 'black pepper');
  N('peppar', 'Peppar', 'Pepper', /peppar|pepper/, 'pepper');

  /* ---- animalic, leather, smoke ---- */
  N('mysk', 'Mysk', 'Musk', /mysk|musk|(^|[^a-zåäö])musc/, 'musk white musk');
  N('lader', 'Läder', 'Leather', /l[äa]der|leather|mocka|suede/, 'suede');
  N('cade', 'Cade', 'Cade (juniper tar)', /(^|[^a-zåäö])cade/, 'juniper tar cadeolja');
  N('rok', 'Rök', 'Smoke', /(^|[^a-zåäö])r[öo]k($|[^a-zåäö])|rökig|smok|tjära|birch tar|(^|[^a-zåäö])tar($|[^a-zåäö])|(^|[^a-zåäö])kol($|[^a-zåäö])|krut/, 'smoky tar');
  N('kastoreum', 'Kastoreum', 'Castoreum', /kastoreum|castoreum|bävergäll|bavergall/, 'castoreum beaver');
  N('civet', 'Civet', 'Civet', /civet|sibet/);
  N('animalisk', 'Animaliska noter', 'Animalic notes', /animalisk|animalic/, 'animalic');

  /* ---- marine, mineral, molecules, abstract ---- */
  N('marina', 'Marina noter', 'Marine notes', /marin|havs|ozon|ocean|aquatic|calone|tång|seaweed|(^|[^a-zåäö])salt($|[^a-zåäö])|(^|[^a-zåäö])sea($|[^a-zåäö])/, 'sea salt ozone aquatic seaweed');
  N('vatten', 'Vatten & regn', 'Water & rain', /vatten|water|regn|rain/, 'water rain');
  N('mineral', 'Mineraler & metall', 'Minerals & metal', /mineral|(^|[^a-zåäö])sten($|[^a-zåäö])|stone|flint|metall|metal/, 'metal stone');
  N('jord', 'Jordiga noter', 'Earthy notes', /jordig|jordnot|earthy|(^|[^a-zåäö])jord($|[^a-zåäö])|petrichor|(^|[^a-zåäö])soil/, 'earth soil');
  N('gummi', 'Gummi', 'Rubber', /gummi|rubber/);
  N('aldehyder', 'Aldehyder', 'Aldehydes', /aldehyd/);
  N('puder', 'Puder', 'Powder', /puder|pudrig|powder/, 'powdery');
  N('isoe', 'Iso E Super', 'Iso E Super', /iso ?e ?super/, 'iso e');
  N('hedione', 'Hedione', 'Hedione', /hedione/);
  N('amylsalicylat', 'Amylsalicylat', 'Amyl salicylate', /amyl ?salicyl/);
  N('shamama', 'Shamama-ackord', 'Shamama accord', /shamama/, 'shamama attar');

  /* ---- general fallbacks (must stay last) ---- */
  N('frukt', 'Frukt', 'Fruit', /frukt|fruit/, 'fruity');
  N('bar', 'Bär', 'Berries', /(^|[^a-zåäö])b[äa]r($|[^a-zåäö])|berries|berry/, 'berry');
  N('blommor', 'Blommor', 'Flowers', /blomm|bloom|flower|floral|bukett|bouquet/, 'floral flowers');
  N('tra', 'Trä', 'Wood', /(^|[^a-zåäö])trä($|[^a-zåäö])|[a-zåäö]trä($|[^a-zåäö])|träig|woody|(^|[^a-zåäö])wood|bambu|bamboo|teak|drivved|driftwood|björk|birch|(^|[^a-zåäö])ek($|[^a-zåäö])/, 'woody');
  N('kryddor', 'Kryddor', 'Spices', /krydd|spice|spicy|exotic/, 'spicy');
  N('grona', 'Gröna noter', 'Green notes', /gr[öo]n|green/, 'green leaves');

  var cache = {};
  var byId = {};
  rules.forEach(function (r) { if (!byId[r.id]) byId[r.id] = r; });

  function classify(raw) {
    var key = String(raw == null ? '' : raw).toLowerCase().trim();
    if (cache[key]) return cache[key];
    var hit = null;
    for (var i = 0; i < rules.length; i++) {
      if (rules[i].rx.test(key)) { hit = rules[i]; break; }
    }
    var out;
    if (hit) {
      var first = byId[hit.id];
      out = { id: hit.id, sv: first.sv, en: first.en, alias: first.alias, known: true };
    } else {
      var nice = key.charAt(0).toUpperCase() + key.slice(1);
      out = { id: 'x-' + fold(key).replace(/[^a-z0-9]+/g, '-'), sv: nice, en: nice, alias: '', known: false };
    }
    cache[key] = out;
    return out;
  }

  function root() {
    try { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; } catch (e) { return '/'; }
  }
  /* note profile page (metaobject type note_profile, url handle noter) */
  function profileUrl(id) { return root() + 'pages/noter/' + id; }

  window.GassasNotes = { classify: classify, fold: fold, rules: rules, byId: byId, profileUrl: profileUrl, root: root };
})();
